import { useNotification } from "naive-ui";
import * as env from "@/config/env";
import * as common from "@/assets/common/common";
import { useRouter } from "vue-router";
import { USER_ROUTES } from "@/assets/route_constants";
import { getAuth } from "firebase/auth";
export function useDownload() {
  const notification = useNotification();
  const router = useRouter();
  const auth = getAuth();
  async function downloadReportFile(
    reportFileIdentifier: string | undefined,
    downloadFilename: string | undefined
  ) {
    if (!reportFileIdentifier) {
      notification.error({
        title: "오류",
        description: "다운로드할 파일 정보가 없습니다.",
        duration: 3000,
      });
      return;
    }

    try {
      if (!auth.currentUser) {
        notification.error({
          title: "인증 필요",
          description:
            "파일을 다운로드하려면 로그인이 필요합니다. 다시 로그인해주세요.",
          duration: 5000,
        });
        router.push({ name: USER_ROUTES.Login.Name }); // LOGIN 라우트 이름 확인 필요
        return;
      }
      const idToken = await auth.currentUser.getIdToken(true);

      const downloadFunctionUrl = env.getRequestEndpoint("createxUserDownload");
      if (!downloadFunctionUrl || typeof downloadFunctionUrl !== "string") {
        throw new Error("다운로드 서비스 URL을 가져올 수 없습니다.");
      }

      const response = await fetch(downloadFunctionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ fileId: reportFileIdentifier }),
      });

      if (!response.ok) {
        let errorBodyText = `HTTP 오류: ${response.status}`;
        try {
          const errorResult = await response.json();
          errorBodyText =
            common.getResultError(errorResult) ||
            errorResult.message ||
            errorResult.error ||
            `서버 오류: ${response.status}`;
        } catch (e) {
          // 응답이 JSON이 아니거나 파싱 실패 시 statusText 사용
          errorBodyText =
            response.statusText || `서버 오류: ${response.status}`;
        }
        throw new Error(errorBodyText);
      }

      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = downloadFilename ? downloadFilename : "report"; // 기본 파일명

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = decodeURIComponent(filenameMatch[1]);
        }
      }

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      notification.success({
        title: "성공",
        description: `${filename} 파일 다운로드가 시작되었습니다.`,
        duration: 3000,
      });
    } catch (error: any) {
      console.error("파일 다운로드 실패:", error);
      notification.error({
        title: "다운로드 실패",
        description: error.message || "파일 다운로드 중 오류가 발생했습니다.",
        duration: 5000,
      });
    } finally {
    }
  }
  async function downloadNormalFile(
    fileId: string | undefined,
    downloadFilename: string | undefined
  ) {
    if (!fileId) {
      notification.error({
        title: "오류",
        description: "다운로드할 파일 정보가 없습니다.",
        duration: 3000,
      });
      return;
    }

    try {
      const downloadFunctionUrl = env.getRequestEndpoint("normalFileDownload");
      if (!downloadFunctionUrl || typeof downloadFunctionUrl !== "string") {
        throw new Error("다운로드 서비스 URL을 가져올 수 없습니다.");
      }

      const response = await fetch(downloadFunctionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileId: fileId }),
      });

      if (!response.ok) {
        let errorBodyText = `HTTP 오류: ${response.status}`;
        try {
          const errorResult = await response.json();
          errorBodyText =
            common.getResultError(errorResult) ||
            errorResult.message ||
            errorResult.error ||
            `서버 오류: ${response.status}`;
        } catch (e) {
          // 응답이 JSON이 아니거나 파싱 실패 시 statusText 사용
          errorBodyText =
            response.statusText || `서버 오류: ${response.status}`;
        }
        throw new Error(errorBodyText);
      }

      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = downloadFilename ? downloadFilename : "report"; // 기본 파일명

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (filenameMatch && filenameMatch.length > 1) {
          filename = decodeURIComponent(filenameMatch[1]);
        }
      }

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      notification.success({
        title: "성공",
        description: `${filename} 파일 다운로드가 시작되었습니다.`,
        duration: 3000,
      });
    } catch (error: any) {
      console.error("파일 다운로드 실패:", error);
      notification.error({
        title: "다운로드 실패",
        description: error.message || "파일 다운로드 중 오류가 발생했습니다.",
        duration: 5000,
      });
    } finally {
    }
  }
  return {
    downloadReportFile,
    downloadNormalFile,
  };
}
